<template lang="jade">
  .layout_card(v-el:content)
    //- functions for the switcher
    .card__inner.clearfix(v-if="isSwitcher && switcherLayout === 1 && cardType=== 'function'")
      .card__header.clearfix
        .function_name.card__header__inner.col-md-12.no_pad.clearfix
          span.title &nbsp;
      .card__block.function_card.clearfix
        img(v-bind:src="layoutImgSrc")
      .card__footer.clearfix
        span &nbsp;
    .card__inner.clearfix(v-if="isSwitcher && switcherLayout === 2 && cardType=== 'function'")
      .card__header.clearfix
        .function_name.card__header__inner.col-md-12.no_pad
          span.title &nbsp;
      .card__block.function_card.clearfix
        img(v-bind:src="layoutImgSrc")
      .card__footer.clearfix
        span &nbsp;
    .card__inner.clearfix(v-if="isSwitcher && switcherLayout === 3 && cardType=== 'function'")
      .card__header.clearfix
        .function_name.card__header__inner.col-md-12.no_pad
          span.title &nbsp;
      .card__block.function_card.clearfix
        img(v-bind:src="layoutImgSrc")
      .card__footer.clearfix
        span &nbsp;

</template>


<script>
import $ from 'jquery'
import { photos } from 'src/Service'
import _ from 'lodash'
import Indicator from 'components/Indicator.vue'
export default {
  components: {
    Indicator
  },
  props: {
    isInstaller: {
      type: Boolean
    },
    cardType: {
      type: null
    },
    outputData: {
      type: null
    },
    inputData: {
      type: null
    },
    isFavorite: {
      type: Boolean
    },
    outputFocus: null,
    inputFocus: null,
    inputId: {
      type: String
    },
    highlightInputId: {
      type: Boolean,
      default: false
    },
    isSwitcher: {
      type: Boolean,
      default: false
    },
    switcherLayout: {
      type: Number,
      default: 0
    },
    layoutImgSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    isOut () {
      return this.cardType === 'output'
    },
    isDesktopFocused () {
      return (this.isOut && this.outputFocus === Number(this.outputData._id)) ||
        (!this.isOut && this.inputFocus === Number(this.inputData._id))
    },
    isMobileFocused () {
      return !this.isOut && Number(this.inputFocus) === Number(this.inputData._id)
    }
  },
  data () {
    return {
      inputImgs: photos.inputs,
      outputImgs: photos.outputs
    }
  },
  methods: {
    cardClick () {
      this.$emit('focus', this.isOut ? this.outputData._id : this.inputData._id)
    }
  },
  ready () {
    let ele = this.$els.content
    ele.move = (left, top, cb) => {
      $(ele).css({
        transform: `translate(${left}px, ${top}px) scale(0)`
      }).addClass('moving')
      setTimeout(() => {
        $(ele).css({
          transform: 'none'
        }).addClass('moved')
        setTimeout(() => {
          $(ele).css({
          }).removeClass('moving moved')
        }, 200)
        cb()
      }, 600)
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      let key = Object.keys(event.inputs)[0]
      // @@@ Todo:  can't use this.inputData._id here , need to figure it out
      if (key === this.inputId) {
        console.log(event)
        console.log(this.inputData)
        let newInputData = _.cloneDeep(this.inputData)
        newInputData.link = event.inputs[key]
        this.inputData = _.cloneDeep(newInputData)
        console.log(this.inputData)
      }
    }
  }
}
</script>

<style lang='scss'>
  @import '~__vendor_variables_scss__';
  /* use it to set breakpoints */
  @import '~sass/_breakpoint.scss';
  .output_name{
    position: relative;
  }
  .layout_card{
    width: 12.5%;
    padding-left:10px;
    padding-right: 10px;
    float: left;
    margin-bottom: $space_sm;
    position: relative;

    /* card clicked styles */
    &.highlight .card__inner {
      background: $MatrixCard_bg_highlight;
      .input_id {
        // background: linear-gradient(90deg, hsl(200,20%,50%) 0%, hsl(200,20%,30%) 100%);
        background: rgba(0,0,0,0.7);
        color: $MatrixCard_id_fg_highlight;
      }
      img {
        filter: $MatrixCard_filter__highlight;
      }
    }

    .card__inner{
      overflow:hidden;
      border-radius:$base_border_radius;
      border:1px solid $MatrixCard_border;
      transition: all 0.2s linear;
      background: $MatrixCard_bg;
      .right {
        display: inline-block;
        width: 60px;
        height: 20px;
        top: 2px;
        right: 4px;
        position: absolute;
        text-align: right;
        .fa { margin-right: 2px; }
        .favorite{
          font-size: 10px;
          color: $GLOBAL_heart_fg;
          top: -3px;
          position: relative;
        }
        .encrypted {
          font-size: 10px;
          top: -3px;
          position: relative;
        }
      }
      img {
          filter: $MatrixCard_filter;
      }
      &.clicked{
        background: $MatrixCard_bg_clicked;
        box-shadow: -1px 4px 10px 0 #555;
        transform: scale(1.2);
        transition: all 0.2s;
        border-radius:7px;
        border: 1px solid hsl(200,50%,10%);
        position: relative;
        z-index: 20;
        img {
          filter: $MatrixCard_filter__clicked;
        }
        .input_id {
          background: rgba(0,0,0,0.6);
          color: $MatrixCard_id_fg_clicked;
          border: 1px solid rgba(0,0,0,0.6);
        }
        .card__header,.card__footer{
          color: $MatrixCard_fg_clicked;
          span,.btn{
            color: $MatrixCard_fg_clicked;
          }
          .line{
            // background-color:$card_clicked_bg;
          }
        }
        .card_all,.card_mute{
          color: $MatrixCard_fg_clicked;
          border-radius:$base_border_radius;
        }
      }
    }
    /* ==== card header ==== */
    &.mobile-highlight {
      .card__inner {
        background: $MatrixCard_bg_highlight;
        .input_id {
          // background: linear-gradient(90deg, hsl(200,20%,50%) 0%, hsl(200,20%,30%) 100%);
          background: rgba(0,0,0,0.7);
          color: #fff;
        }
      }
    }
  }
  .output__card__single{
    transition:all .5s;
  }

  .card__header{
    /* border-radius:$base_border_radius $base_border_radius 0px 0px; */
    width: 100%;
    color: $MatrixCard_fg;
    .card__header__inner{
      float: left;
    }

    .function_name {
      .title {
        display: block;
        margin-left: 6px;
      }
    }

    .output_name {
      position: relative;
      .title {
        font-weight: bold;
        margin-left: 6px;
        padding-top: 4px;
        .id {
          margin-right: 6px;
        }
      }
      & h2 {
        margin-top: 0px;
        margin-bottom: 0px;
        font-size: 18px;
        font-weight: bold;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        & span{
          color: $MatrixCard_fg;
          display:inline-block;
          height: 100%;
          padding:5px;
          border-radius:$base_border_radius $base_border_radius $base_border_radius 0;
        }

      }

      & .hdmi,.hdcp {
        position: absolute;
        left:19px;
        top:5px;
        & span{
          text-transform:uppercase;
          position: relative;
        }
      }
      & .hdcp{
        top:12px;
      }

    }
  }

  /*  ===== card block ===== */
  .card__block{
    height:$basic_card_height;

    @include breakpoint(xxs){
      height:$mobile_card_height;
    }
    position: relative;
    overflow:hidden;
    /* for chrome Firefox */
    /* 用來置中<img>的 */
    text-align: center;
    line-height:64px;
    /* IE */
    font-size: 72px;
    font-family: Arial;
    img{
      margin-left: auto;
      margin-right: auto;
      object-fit:contain;
      /* display:inline-block; */
      vertical-align:middle;
    }
  }

  /* === function block */
  .card__block.function_card {
    img {
      height: 100%;
      width: auto;
      filter: invert(0%);
    }
  }

  .input_id{
    border:1px solid rgba(0,0,0,0.4);
    background-color: rgba(255,255,255,0.4);
    color: rgba(0,0,0,0.6);
    position: absolute;
    box-sizing:border-box;
    border-radius:50%;
    width: 40px;
    height: 40px;
    overflow:hidden;
    right: 5px;
    bottom:5px;

    /* for chrome Firefox */
    /* 用來置中<img>的 */
    line-height:40px;
    /* IE */
    font-size: 36px;
    font-family: Arial;
    & img{
      display:inline-block;
      vertical-align:middle;
    }
    .fa {
      position: relative;
      font-size: 34px;
      padding: 0;
      top: -2px;
    }
  }

  .input__card__block{
    @include breakpoint(xxs) {
      height:$mobile_input_card_height;
      line-height:$mobile_input_card_height;
    }
    /* line-height:100px; */
    /* padding:20px; */
    /* for chrome Firefox */
    /* 用來置中<img>的 */
    text-align: center;
    line-height:28px;
    /* IE */
    font-size: 72px;
    font-family: Arial;
    & .img-responsive{
      display:inline-block;
      vertical-align:middle;
    }
    & .fa {
      font-size: 64px;
      margin-top: -8px;
      margin-left: 0;
    }
  }

  .card_all{
    height: 50px;
    line-height:50px;
    padding: 0;
    & .all{
      font-size:24px;
      height: 100%;
    }
    @include breakpoint(xxs) {
      height: $mobile_card_all_height;
      line-height:$mobile_card_all_height;
    }
    @include breakpoint(sm) {
      height: 123px;
      line-height:140px;
    }
    @include breakpoint(md) {
      height: 30px;
      line-height: 40px;
    }
  }
  .outMute{
    .card__footer{
      display:none;
    }
    .input__card__block{
      padding: 0;
      .fa{
        font-size: 30px;
      }
    }
  }
  .card_mute{
    color: $MatrixCard_fg;
    text-align:center;
    font-size: 32px;
    height: $mute_card_height;
    line-height:$mute_card_height;
    @include breakpoint(xxs) {
      height:$mobile_card_mute_height;
      line-height:$mobile_card_mute_height;
    }
    span{
      font-size: 14px;
      /* font-family: $base_font_family; */
      margin-left: 5px;
    }
  }
  .fa-times{
    color:#f00;
  }

  .card__footer{
    /* border-radius:0px 0px $base_border_radius $base_border_radius; */
    color: $MatrixCard_fg;
    width: 100%;
    padding:3px 3px 5px 3px;
    position: relative;
    overflow:hidden;
    .card_footer_inner{
      float: left;
    }
    .input_name {
      float: right;
      margin-right: 6px;
    }
    .input_btns{
      position: relative;
      .btn{
        position: absolute;
        left: -6px;
        bottom: -6px;
        color: $MatrixCard_fg;
      }
    }
  }

  .line{
    width: 100%;
    height: 3px;
    position: absolute;
    bottom:0px;
    left: -1px;
    & .line__inner{
      position: absolute;
      left: 0;
      top: 0;
      display:block;
      height: 3px;
      &.width33{
        width: 33%;
        background-color:#f00;
      }
      &.width66{
        width: 66%;
        background-color:#e6b939;
      }
      &.width100{
        background-color:$pri_green;
        width: 100%;
      }
    }
  }
  /* ============ responsive =============*/
  /* ipad */
  @include breakpoint(md){
    .layout_card{
      width: 25%;
    }
  }
  @include breakpoint(sm){
    .layout_card{
      width:25%;
    }
  }
  /* iphone */
  @include breakpoint(xxs){
    .layout_card {
      width: 100%;
      display:inline-block;
    }
    .layout_card.outAll{
      width:30%;
    }

  }
  .moving {
    transition: all .8s ease !important;
    &.moved {
      transition: all .001s !important;
    }
  }
  @include breakpoint(iFive){
    .layout_card {
      margin-bottom: 0;
    }
    .card__block{
      height:80px;
    }
    .input__card__block{
      height:85px;
    }
    .card_all,.card_mute{
      /* 會跟card__inner差3px */
      height:110px;
      line-height:110px;
    }
  }

  .input_header{
    & .title{
      display: inline-block;
      width: 100%;
    }
    & .pull-right{
      float: right;
      padding-right: 4px;
      padding-top: 2px;
    }
  }

</style>



// WEBPACK FOOTER //
// LayoutCard.vue?55635d07